import React from 'react';
import { Link } from 'react-router-dom';
import SearchFilter from '../filters/SearchFilter';
import Lang from '../../lang';
import TitleBar from '../common/title_bar';

const filters = {
  Tabs: {
    Schedule: [
      {
        key: 'title',
        displayKey: 'Search By Title',
        inputType: 'text'
      },
      {
        key: 'entity',
        displayKey: 'Search By Entity',
        inputType: 'text'
      },
      {
        key: 'status',
        displayKey: 'Search By Status',
        inputType: 'text'
      },
      {
        key: 'observation',
        displayKey: 'Search By Observation',
        inputType: 'text'
      },
      {
        key: 'attendance',
        displayKey: 'Search By Attendance',
        inputType: 'text'
      }
    ]
  },
  checkbox: []
};

class ScheduleFilterComponent extends React.Component {
  render() {
    return (
      <div className="inner-container">
        <div className="outer-space">

          <TitleBar path="/create_schedule" title={Lang.langCheck.langRequest('Schedule')} logo="agenda" />
          <SearchFilter filters={filters} handleFilter={(data) => this.props.handleFilter(data)} data={this.props.data} />
        </div>
      </div>
    );
  }
}

export default ScheduleFilterComponent;
